import FlashCard from "../../components/student/FlashCard";
import { Layout } from "../../components/layout/Layout";
import { BookOpen } from "lucide-react";

interface CardData {
  letter: string;
  word: string;
  meaning: string;
  image?: string; 
  letterAudio?: string;  // 👈 NEW
  wordAudio?: string; 
}

const uyirLetters: CardData[] = [
  { letter: 'அ', word: 'அம்மா', meaning: 'Mother', image: '/images/uyir/amma.jpg',letterAudio: '/audio/uyir/a.mp3',
    wordAudio: '/audio/uyir/amma.mp3', },
  { letter: 'ஆ', word: 'ஆடு', meaning: 'Goat', image: '/images/uyir/aadu.jpg',letterAudio: '/audio/uyir/aa.mp3',
    wordAudio: '/audio/uyir/aadu.mp3' },
  { letter: 'இ', word: 'இலை', meaning: 'Leaf', image: '/images/uyir/ilai.jpg',letterAudio: '/audio/uyir/இ.mp3', wordAudio: '/audio/uyir/ilai.mp3' },
  { letter: 'ஈ', word: 'ஈ', meaning: 'Fly', image: '/images/uyir/ee.jpg',letterAudio: '/audio/uyir/eee.mp3',
    wordAudio: '/audio/uyir/eee.mp3' },
  { letter: 'உ', word: 'உலகம்', meaning: 'World', image: '/images/uyir/ulagam.jpg',letterAudio: '/audio/uyir/vu.mp3',
    wordAudio: '/audio/uyir/ulagam.mp3' },
  { letter: 'ஊ', word: 'ஊஞ்சல்', meaning: 'Swing', image: '/images/uyir/swing.jpg',letterAudio: '/audio/uyir/voo.mp3',
    wordAudio: '/audio/uyir/oonjal.mp3' },
  { letter: 'எ', word: 'எலி', meaning: 'Mouse', image: '/images/uyir/eli.jpg',letterAudio: '/audio/uyir/ye.mp3',
    wordAudio: '/audio/uyir/eli.mp3' },
  { letter: 'ஏ', word: 'ஏணி', meaning: 'Ladder', image: '/images/uyir/ladder.jpg',letterAudio: '/audio/uyir/yee.mp3',
    wordAudio: '/audio/uyir/yeni.mp3' },
  { letter: 'ஐ', word: 'ஐந்து', meaning: 'Five', image: '/images/uyir/five.jpg',letterAudio: '/audio/uyir/ii.mp3',
    wordAudio: '/audio/uyir/aindhu.mp3' },
  { letter: 'ஒ', word: 'ஒட்டகம்', meaning: 'Camel', image: '/images/uyir/camel.jpg',letterAudio: '/audio/uyir/vo.mp3',
    wordAudio: '/audio/uyir/ottagam.mp3' },
  { letter: 'ஓ', word: 'ஓடை', meaning: 'Stream', image: '/images/uyir/stream.jpg',letterAudio: '/audio/uyir/oo.mp3',
    wordAudio: '/audio/uyir/oodai.mp3' },
  { letter: 'ஔ', word: 'ஔவை', meaning: 'Poet Avvaiyar', image: '/images/uyir/avvaiyar.jpg',letterAudio: '/audio/uyir/aww.mp3',
    wordAudio: '/audio/uyir/avvai.mp3' },
];

const meiLetters: CardData[] = [
  { letter: 'க்', word: 'தக்காளி', meaning: 'Tomato',image: '/images/mei/tomato.jpg',letterAudio: '/audio/mei/ikk.mp3',
    wordAudio: '/audio/mei/tomato.mp3' },
  { letter: 'ங்', word: 'சிங்கம்', meaning: 'Lion',image: '/images/mei/lion.jpg',letterAudio: '/audio/mei/ing.mp3',
    wordAudio: '/audio/mei/lion.mp3' },
  { letter: 'ச்', word: 'எலுமிச்சை', meaning: 'Lemon',image: '/images/mei/lemon.jpg',letterAudio: '/audio/mei/ich.mp3',
    wordAudio: '/audio/mei/lemon.mp3' },
  { letter: 'ஞ்', word: 'ஊஞ்சல்', meaning: 'Swing',image: '/images/uyir/swing.jpg',letterAudio: '/audio/mei/injh.mp3',
    wordAudio: '/audio/uyir/oonjal.mp3' },
  { letter: 'ட்', word: 'சட்டை', meaning: 'Shirt',image: '/images/mei/shirt.jpg',letterAudio: '/audio/mei/it.mp3',
    wordAudio: '/audio/mei/shirt.mp3' },
  { letter: 'ண்', word: 'வண்டு', meaning: 'Beetle',image: '/images/mei/beetle.jpg',letterAudio: '/audio/mei/inn.mp3',
    wordAudio: '/audio/mei/beetle.mp3' },
  { letter: 'த்', word: 'வாத்து', meaning: 'Duck',image: '/images/mei/duck1.jpg',letterAudio: '/audio/mei/ith.mp3',
    wordAudio: '/audio/mei/duck.mp3' },
  { letter: 'ந்', word: 'ஆந்தை', meaning: 'Owl',image: '/images/mei/owl.jpg',letterAudio: '/audio/mei/inth.mp3',
    wordAudio: '/audio/mei/owl.mp3' },
  { letter: 'ப்', word: 'சீப்பு', meaning: 'comb',image: '/images/mei/comb.jpg',letterAudio: '/audio/mei/ipp.mp3',
    wordAudio: '/audio/mei/comb.mp3' },
  { letter: 'ம்', word: 'மாம்பழம்', meaning: 'Mango',image: '/images/mei/mango.jpg',letterAudio: '/audio/mei/imm.mp3',
    wordAudio: '/audio/mei/mango.mp3' },
  { letter: 'ய்', word: 'நாய்', meaning: 'Dog',image: '/images/mei/dog.jpg',letterAudio: '/audio/mei/iyi.mp3',
    wordAudio: '/audio/mei/dog.mp3' },
  { letter: 'ர்', word: 'தேர்', meaning: 'Chariot',image: '/images/mei/chariot.jpg',letterAudio: '/audio/mei/ir.mp3',
    wordAudio: '/audio/mei/ther.mp3' },
  { letter: 'ல்', word: 'மயில்', meaning: 'Peacock',image: '/images/mei/peacock.jpg',letterAudio: '/audio/mei/il.mp3',
    wordAudio: '/audio/mei/mayil.mp3' },
  { letter: 'வ்', word: 'செவ்வந்தி', meaning: 'Chrysanthemum',image: '/images/mei/Chrysanthemum.jpg',letterAudio: '/audio/mei/ivv.mp3',
    wordAudio: '/audio/mei/sevvandhi.mp3' },
  { letter: 'ழ்', word: 'யாழ்', meaning: 'harp',image: '/images/mei/harp.jpg',letterAudio: '/audio/mei/illl.mp3',
    wordAudio: '/audio/mei/yazh.mp3'},
  { letter: 'ள்', word: 'தேள்', meaning: 'Scorpion',image: '/images/mei/scorpion.jpg',letterAudio: '/audio/mei/illll.mp3',
    wordAudio: '/audio/mei/thel.mp3' },
  { letter: 'ற்', word: 'பாகற்காய்', meaning: 'Bitter Gourd',image: '/images/mei/Bitter Gourd.jpg',letterAudio: '/audio/mei/irr.mp3',
    wordAudio: '/audio/mei/bitter.mp3' },
  { letter: 'ன்', word: 'மான்', meaning: 'Deer',image: '/images/mei/deer.jpg',letterAudio: '/audio/mei/inn.mp3',
    wordAudio: '/audio/mei/maan.mp3' },
];

const pastelColors = [
  'bg-pink-200',
  'bg-blue-200',
  'bg-green-200',
  'bg-yellow-200',
  'bg-purple-200',
  'bg-orange-200',
  'bg-teal-200',
  'bg-rose-200',
  'bg-indigo-200',
  'bg-lime-200',
  'bg-cyan-200',
  'bg-fuchsia-200',
];

function TamilPhonicsFlashcards() {
  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-pink-50 to-blue-50 py-12 px-4">
        <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <BookOpen className="w-12 h-12 text-orange-500 mr-3" />
            <h1 className="text-5xl font-bold text-gray-800">
              தமிழ் ஒலியியல் – ஃப்ளாஷ் கார்டுகள்
            </h1>
          </div>
          <p className="text-xl text-gray-600 mt-2">
            Tamil Phonics Flashcards - Click to flip!
          </p>
        </div>

        {/* Uyir cards */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-8 text-blue-600">
            உயிர் எழுத்துக்கள் (Uyir Eluthukkal)
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
            {uyirLetters.map((card, index) => (
              <FlashCard
                key={index}
                letter={card.letter}
                word={card.word}
                meaning={card.meaning}
                image={card.image}
                letterAudio={card.letterAudio}   // 👈
                wordAudio={card.wordAudio}       // 👈
                color={pastelColors[index % pastelColors.length]}
              />
            ))}
          </div>
        </div>

        {/* Mei cards */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-center mb-8 text-green-600">
            மெய் எழுத்துக்கள் (Mei Eluthukkal)
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
            {meiLetters.map((card, index) => (
              <FlashCard
                key={index}
                letter={card.letter}
                word={card.word}
                meaning={card.meaning}
                image={card.image}
                letterAudio={card.letterAudio}   // 👈
                wordAudio={card.wordAudio}
                color={pastelColors[index % pastelColors.length]}
              />
            ))}
          </div>
        </div>

        <div className="text-center mt-12 p-6 bg-white rounded-2xl shadow-lg">
          <p className="text-lg text-gray-700">
            <span className="font-bold text-orange-600">Tip:</span> Click any card to see the example word and its meaning!
          </p>
        </div>
        </div>
      </div>
    </Layout>
  );
}

export default TamilPhonicsFlashcards;
